const SKIP_SORT_COLUMN_IDS = new Set(['selection', 'actions']);

const PREFERRED_SORT_VALUES = ['updatedAt:desc', 'createdAt:desc', 'overdueDay:asc', 'accountsReceivable:desc', 'currentAccountsReceivable:desc'];

export const getAdvanceTableColumnSortLabel = (column) => {
	const header = column.columnDef.header;
	if (typeof header === 'string') {
		return header;
	}
	return column.id;
};

export const buildAdvanceTableMobileSortOptions = (table) => {
	if (!table?.getAllColumns) {
		return [];
	}

	return table
		.getAllColumns()
		.filter((col) => col.getCanSort() && !SKIP_SORT_COLUMN_IDS.has(col.id))
		.flatMap((col) => {
			const label = getAdvanceTableColumnSortLabel(col);
			return [
				{ value: `${col.id}:desc`, label: `${label}（降序）` },
				{ value: `${col.id}:asc`, label: `${label}（升序）` },
			];
		});
};

export const getAdvanceTableMobileSortValue = (sorting, sortOptions) => {
	if (sorting?.[0]?.id) {
		return `${sorting[0].id}:${sorting[0].desc ? 'desc' : 'asc'}`;
	}

	const preferred = PREFERRED_SORT_VALUES.find((value) => sortOptions.some((option) => option.value === value));
	return preferred ?? sortOptions[0]?.value ?? '';
};

export const parseAdvanceTableMobileSortValue = (value) => {
	const [id, dir] = String(value).split(':');
	if (!id) {
		return [];
	}
	return [{ id, desc: dir !== 'asc' }];
};
